  var doInfinite = function() {
    var url = $(location).attr('href'),
        parts = url.split("/"),
        last_part = parts[parts.length-1];      
    
    // var col_name = $('#localization_formtoolbar input[name=return_to]').val(),
    //     cols = col_name.split("/"),
    //     col = cols[cols.length-1].split("?")[0]; 
    var  col = parts[parts.length-1].split("?")[0]; 

        if(last_part.includes("sort_by")){
          var col_name = last_part.slice(0, last_part.indexOf('?', 0)),
              str= (last_part + '&').replace(col_name + '?', ''),
              startIndex = str.indexOf('sort_by='),
              endIndex = (str.indexOf('&', startIndex) + 1);


          if (endIndex === -1) {endIndex = str.length;}
          var sort_val = str.slice(startIndex, endIndex),
              sort = sort_val.replace('&',''),
              filter_val = str.replace(sort_val, '');

          if (filter_val.charAt(0) === "&") {filter_val = filter_val.slice(1);}

          if (filter_val.charAt(filter_val.length - 1) === "&") {filter_val = filter_val.slice(0, filter_val.length - 1);}

          if (filter_val){filter_val = filter_val + '&'}
          
          //console.log(col_name + "?" + filter_val + 'page={{#}}&' + sort);

          $('.grid--uniform').infiniteScroll({ // options
            path: col_name + "?" + filter_val + 'page={{#}}&' + sort,
            append: '.grid-product',
            hideNav: '.pagination',
            history: false
          });
  
        }else{
          if(last_part.includes("filter")){
             //console.log("filter no sort", last_part);
            $('.grid--uniform').infiniteScroll({ // options
              path: last_part + '&page={{#}}',
              append: '.grid-product',
              hideNav: '.pagination',
              history: false
            });
          }else{
            //console.log("no filter no sort", col);
            $('.grid--uniform').infiniteScroll({ // options
              path: col + '?page={{#}}',
              append: '.grid-product',
              hideNav: '.pagination',
              history: false
            });
          };
          
      };
    };
  
  doInfinite();
  document.addEventListener('collection:reloaded', doInfinite);
  
    var doAnimations = function() {
      var $window = $(window);
      var offset = $window.scrollTop() + $window.height(),
          $animatables = $('.grid--uniform .grid-product__content');
  
      if ($animatables.length == 0) {
        $window.off('scroll', doAnimations);
      }
  
      $animatables.each(function(i) {
          var $animatable = $(this);
          if (($animatable.offset().top + 20) < offset) {
              $animatable.addClass('animated');
          }
      });
  };
  doAnimations();
  $(window).on('scroll', doAnimations);
    